export const FLOW_NAME = "clustering";
export type FLOW_TYPE = "clustering";

export const INPUT_DATA = "data";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const TIMESTAMP_VAR = "time-column";

export const RECIPE = "profilecluster-rows";

export const ID_VARS_KEY = "id-vars";

// Hyper Params
export const MIN_NUM_TOPICS_KEY = "min-num-topics";
export const DEFAULT_MIN_TOPICS = 2;

export const MAX_NUM_TOPICS_KEY = "max-num-topics";
export const DEFAULT_MAX_TOPICS = 10;

export const BIN_COUNT_KEY = "bin-count";
export const DEFAULT_BIN_COUNT = 5;

export const MAX_FEATURES_KEY = "max-features";
export const DEFAULT_MAX_FEATURES = 25;

export const CUSTOM_BINS = "bins";
export const DEFAULT_CUSTOM_BINS = [];

// Algorithms
export const K_MEANS_ALGO = "weighted-k-means";
export const LDA_ALGO = "lda";
